import React, { useCallback, useReducer } from 'react';
import {
	PLP_ACTIONS,
	PLP_ACTIONS_TYPES,
	BreadcrumbsType,
	ContextModal,
	PLP_STATE,
} from '@/data/context/content';

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function reducer(state: PLP_STATE, action: PLP_ACTIONS): PLP_STATE {
	switch (action.type) {
		case PLP_ACTIONS_TYPES.SET_OPEN:
			return { ...state, open: action.payload };
		case PLP_ACTIONS_TYPES.SET_TOTAL:
			return { ...state, total: action.payload };
		case PLP_ACTIONS_TYPES.SET_BREADCRUMBS:
			return { ...state, breadCrumbs: action.payload };
		default:
			return state;
	}
}

const initialState: PLP_STATE = {
	open: false,
	total: 0,
	breadCrumbs: [],
};

export const PLPProviderContext: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [state, dispatch] = useReducer(reducer, initialState);

	const onSetTotal = useCallback((total: number | string) => {
		dispatch({ type: PLP_ACTIONS_TYPES.SET_TOTAL, payload: total });
	}, []);
	const onSetOpen = useCallback((open: boolean) => {
		dispatch({ type: PLP_ACTIONS_TYPES.SET_OPEN, payload: open });
	}, []);
	const onSetBreadCrumbs = useCallback((breadCrumbs: BreadcrumbsType[]) => {
		dispatch({ type: PLP_ACTIONS_TYPES.SET_BREADCRUMBS, payload: breadCrumbs });
	}, []);

	return (
		<ContextModal.Provider value={{ state, onSetTotal, onSetOpen, onSetBreadCrumbs }}>
			{children}
		</ContextModal.Provider>
	);
};
